import React from 'react';
import RangeIndicatorChart from './RangeIndicatorChart';

interface BodyFatResultadoProps {
  sexo: 'M' | 'F';
  cinturaCm: number;
  pescocoCm: number;
  alturaCm: number;
  quadrilCm?: number; // só para mulheres
}

const getBodyFatCategoria = (sexo: 'M' | 'F', bf: number): string => {
  if (sexo === 'F') {
    if (bf < 14) return 'Atleta';
    if (bf < 21) return 'Fitness';
    if (bf < 25) return 'Aceitável';
    if (bf < 32) return 'Obesidade leve';
    return 'Obesidade severa';
  } else {
    // masculino
    if (bf < 6) return 'Atleta';
    if (bf < 14) return 'Fitness';
    if (bf < 18) return 'Aceitável';
    if (bf < 25) return 'Obesidade leve';
    return 'Obesidade severa';
  }
};

const getFaixas = (sexo: 'M' | 'F') => {
  if (sexo === 'F') {
    return [
      { label: 'Atleta', cor: '#90EE90', min: 0, max: 14 },
      { label: 'Fitness', cor: '#ADD8E6', min: 14, max: 21 },
      { label: 'Aceitável', cor: '#FFD700', min: 21, max: 25 },
      { label: 'Obesidade leve', cor: '#FF7F7F', min: 25, max: 32 },
      { label: 'Obesidade severa', cor: '#FF4500', min: 32, max: 60 },
    ];
  }
  return [
    { label: 'Atleta', cor: '#90EE90', min: 0, max: 6 },
    { label: 'Fitness', cor: '#ADD8E6', min: 6, max: 14 },
    { label: 'Aceitável', cor: '#FFD700', min: 14, max: 18 },
    { label: 'Obesidade leve', cor: '#FF7F7F', min: 18, max: 25 },
    { label: 'Obesidade severa', cor: '#FF4500', min: 25, max: 60 },
  ];
};

const calcularBodyFatNavy = (
  sexo: 'M' | 'F',
  cinturaCm: number,
  pescocoCm: number,
  alturaCm: number,
  quadrilCm?: number
): number => {
  const logAltura = Math.log10(alturaCm);
  if (sexo === 'F') {
    if (!quadrilCm) return NaN; // quadril obrigatório para mulher
    const logMedidas = Math.log10(cinturaCm + quadrilCm - pescocoCm);
    return 163.205 * logMedidas - 97.684 * logAltura - 78.387;
  } else {
    // homem
    const logMedidas = Math.log10(cinturaCm - pescocoCm);
    return 86.010 * logMedidas - 70.041 * logAltura + 36.76;
  }
};

const BodyFatResultado: React.FC<BodyFatResultadoProps> = ({
  sexo,
  cinturaCm,
  pescocoCm,
  alturaCm,
  quadrilCm,
}) => {
  if (
    !sexo ||
    !cinturaCm ||
    !pescocoCm ||
    !alturaCm ||
    cinturaCm <= 0 ||
    pescocoCm <= 0 ||
    alturaCm <= 0 ||
    (sexo === 'F' && (!quadrilCm || quadrilCm <= 0))
  )
    return null;

  const bodyFat = calcularBodyFatNavy(sexo, cinturaCm, pescocoCm, alturaCm, quadrilCm);
  if (isNaN(bodyFat)) return <div>Parâmetros inválidos para cálculo.</div>;

  const categoria = getBodyFatCategoria(sexo, bodyFat);
  const faixas = getFaixas(sexo);

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
        % Gordura Corporal: {bodyFat.toFixed(1)}% ({categoria})
      </div>
      <RangeIndicatorChart value={bodyFat} title="% Gordura Corporal" faixas={faixas} />
    </div>
  );
};

export default BodyFatResultado;
